import { render, staticRenderFns } from "./HotelDetail.vue?vue&type=template&id=9c91195c&scoped=true&"
import script from "./HotelDetail.vue?vue&type=script&lang=js&"
export * from "./HotelDetail.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetail.vue?vue&type=style&index=0&id=9c91195c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c91195c",
  null
  
)

export default component.exports